import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router-dom'
import PrimaryNavRail from './PrimaryNavRail'
import useMediaQueryMatch from '../hooks/useMediaQueryMatch'

/** Bottom bar height when labels visible (icon 40 + label + padding). */
export const BOTTOM_NAV_WITH_LABELS = 72
/** Compact bar when labels hidden. */
export const BOTTOM_NAV_COMPACT = 56

export default observer(function BottomNavBar () {
  const location = useLocation()
  const desktop = useMediaQueryMatch('(min-width: 769px)')
  const narrow = useMediaQueryMatch('(max-width: 380px)')

  const hiddenRoutes = ['/login', '/register', '/forgot-password', '/reset-password']
  if (hiddenRoutes.some((route) => location.pathname.startsWith(route))) {
    return null
  }

  if (desktop) {
    return null
  }

  return <PrimaryNavRail variant="bottom" showLabels={!narrow} />
})

/** Exported for main content offset — use max so padding is always sufficient. */
export const BOTTOM_NAB_HEIGHT = BOTTOM_NAV_WITH_LABELS
